<template>
  <div>
    <div :class="{ 'has-error': $v.teacher.cpf.$error }" class="control-group col-lg-6">
      <label class="control-label" for="teacher_cpf">CPF</label>
      <div class="controls">
        <input
          type="text"
          name="teacher.cpf"
          maxlength="255"
          v-model="teacher.cpf"
          id="teacher_cpf"
          class="form-control"
        />
      </div>
    </div>

    <div :class="{ 'has-error': $v.teacher.email.$error }" class="control-group col-lg-6">
      <label class="control-label" for="teacher_email">Email</label>
      <div class="controls">
        <input
          type="email"
          name="teacher.email"
          maxlength="255"
          v-model="teacher.email"
          id="teacher_email"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  props: ["teacher"],
  data() {
    return {};
  },
  validations: {
    teacher: {
      cpf: { required },
      email: { required }
    }
  },
  components: {},
  methods: {
    hasErrors() {
      this.$v.teacher.$touch();
      if (this.$v.teacher.$error) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {}
};
</script>
